<template>
  <div class="signin">

    <div class="logo">
      <img src="@/ui/assets/images/logo_big.svg" />
    </div>

    <div class="title">
      {{ $t('cmp.signin.loginNote') }}
    </div>

    <!-- Если код еще не отправлен -->
    <div
      class="form-wrapper"
      v-if="!isCodeSent"
    >
      <div class="form-group">
        <label class="form-label required">Email</label>
        <input
          class="form-control"
          v-model="userEmail"
        />
        <div
          class="form-invalid-text"
          v-if="errors['userEmail']"
        >
          {{errors['userEmail']}}
        </div>
      </div>

      <div class="row align-items-center">
        <div class="col-md-8">
          <div class="yacaptcha" ref="yacaptcha"></div>
        </div>
        <div class="col-md-4">
          <Button
            :text="$t('cmp.signin.getCode')"
            :isDisabled="!yaCaptchaToken || isSubmiting"
            :action="() => sendCode()"
          />
        </div>
      </div>
    </div>

    <!-- Если код отправлен -->
    <div
      class="form-wrapper"
      v-if="isCodeSent"
    >
      <div class="form-group">
        <label class="form-label required">{{ $t('cmp.signin.emailCode') }}</label>
        <input
          class="form-control"
          v-model="userCode"
        />
        <div
          class="form-invalid-text"
          v-if="errors['userCode']"
        >
          {{errors['userCode']}}
        </div>
      </div>

      <div class="row justify-content-end">
        <div class="col-md-4">
          <Button
            :text="$t('cmp.signin.signIn')"
            :action="() => signIn()"
          />
        </div>
      </div>
    </div>

    <div class="bottom-links">
      {{ $t('cmp.signin.dontHaveAccount') }} <br>
      <router-link to="/profile/signup" replace>{{ $t('cmp.signin.createAccount') }}</router-link>
    </div>
  </div>
</template>

<script>
import Button from '@/ui/components/Button'
import settingsService from '@/services/SettingsService'
import authService from '@/services/AuthService'
import { EMAIL_REGEX } from '@/utils/Constants'

const YACAPTCHA_KEY = process.env.VUE_APP_YACAPTCHA_KEY;

export default {
  name: 'SignIn',
  props: {
    onSignIn: Function,
  },
  components: {
    Button,
  },

  data() {
    return {
      userEmail: null,
      userCode: null,
      yaCaptchaToken: null,
      isSubmiting: false,
      isCodeSent: false,
      errors: {}
    }
  },

  mounted() {
    this.renderYaCaptcha();
  },

  watch: {
    userEmail: function() {
      // Сбрасываем токен, если email был обновлен после его получения
      if (this.isCodeSent) {
        this.isCodeSent = false;
        this.yaCaptchaToken = null;
        this.renderYaCaptcha();
      }
    }
  },

  methods: {
    loadScript(src) {
      return new Promise(function (resolve, reject) {
        const script = document.createElement('script');
        script.src = src;
        script.onload = resolve;
        script.onerror = reject;
        document.head.appendChild(script);
      });
    },

    async renderYaCaptcha() {
      await this.loadScript('https://captcha-api.yandex.ru/captcha.js?render=onload');

      window.smartCaptcha.render(this.$refs.yacaptcha, {
        sitekey: YACAPTCHA_KEY,
        hl: settingsService.getLocale(),
        callback: (token) => {
          this.yaCaptchaToken = token;
        }
      });
    },

    async sendCode() {
      this.errors = {};

      // Проверка почты
      if (!this.userEmail) {
        this.errors['userEmail'] = 'Поле обязательное';
      } else if (this.userEmail.length && !this.userEmail.match(EMAIL_REGEX)) {
        this.errors['userEmail'] = 'Введите правильный адрес почты';
      }

      if (Object.keys(this.errors).length > 0) {
        return;
      }

      this.isSubmiting = true;

      try {
        this.isCodeSent = await authService.sendCode(this.userEmail, this.yaCaptchaToken);
      } catch (error) {
        this.$toast.open({
          message: error.message,
          type: 'error'
        });
      } finally {
        this.isSubmiting = false;
      }
    },

    async signIn() {
      this.errors = {};

      // Проверка почты
      if (!this.userEmail) {
        this.errors['userEmail'] = 'Поле обязательное';
      } else if (this.userEmail.length && !this.userEmail.match(EMAIL_REGEX)) {
        this.errors['userEmail'] = 'Введите правильный адрес почты';
      }

      // Провека кода
      if (!this.userCode) {
        this.errors['userCode'] = 'Поле обязательное';
      }

      if (Object.keys(this.errors).length > 0) {
        return;
      }

      this.isSubmiting = true;

      try {
        let isSignIn = await authService.signIn(this.userEmail, this.userCode);
        if (isSignIn) {
          this.onSignIn();
        }
      } catch (error) {
        this.$toast.open({
          message: error.message,
          type: 'error'
        });
      } finally {
        this.isSubmiting = false;
      }
    }
  }
}
</script>

<style lang="scss">
.signin {

  .logo {
    margin: 40px 0;
    text-align: center;
  }

  .title {
    text-align: center;
    font-size: 14px;
    padding: 0 20px;
  }

  .form-wrapper {
    padding: 30px 40px;
    margin-bottom: 20px;

    .form-invalid-text {
      font-size: 14px;
      color: $redText;
      margin-top: 3px;
    }
  }

  .bottom-links {
    font-size: 14px;
    text-align: center;
  }
}
</style>